// src/pages/steps/ConfirmationStep.js
import React from "react";
import { useFormContext } from "react-hook-form";
import { useProducts } from "../../pages/ProductContext";
import { Box, Heading, Text, VStack, Divider } from "@chakra-ui/react";

const ConfirmationStep = () => {
  const { getValues } = useFormContext();
  const { cartItems } = useProducts();

  // Henter all data fra form
  const { shipping, payment } = getValues();

  const subtotal = cartItems.reduce((acc, item) => acc + item.price * item.quantity, 0);
  const vat = subtotal * 0.25;
  const total = subtotal + vat;

  return (
    <VStack align="stretch" spacing={4}>
      <Heading as="h2" size="md">Bekreft bestillingen</Heading>
      <Text fontWeight="bold">Fraktinfo:</Text>
      <Box>
        <Text>{shipping.name}</Text>
        <Text>{shipping.address}</Text>
        <Text>
          {shipping.zip} {shipping.city}, {shipping.country}
        </Text>
      </Box>

      <Divider />

      <Text fontWeight="bold">Betalingsinfo:</Text>
      <Box>
        <Text>Kortnummer: {payment.cardNumber}</Text>
        <Text>Utløpsdato: {payment.expiry}</Text>
        {/* Ikke vis CVC i klartekst i en reell app */}
      </Box>

      <Divider />

      <Text fontWeight="bold">Handlekurv:</Text>
      {cartItems.map((item) => (
        <Box key={item.id}>
          <Text>
            {item.name} (x{item.quantity})
          </Text>
        </Box>
      ))}
      <Divider />
      <VStack align="flex-end" spacing={0}>
        <Text>Subtotal: kr {subtotal.toFixed(2)}</Text>
        <Text>MVA (25%): kr {vat.toFixed(2)}</Text>
        <Text fontSize="lg" fontWeight="bold">
          Total: kr {total.toFixed(2)}
        </Text>
      </VStack>
    </VStack>
  );
};

export default ConfirmationStep;